<template lang="pug">
  .component-backoffice-card
    .card
      .inner-content
        card-n(:columns="5", :showBullets="true")
          Dropdown(slot="actionBullets", :icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
            PaymentMethodButtons(:item="item", @refresh="$emit('itemUpdated')")
            //dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
              CouponButtons(:item="item", @itemUpdated="$emit('itemUpdated')")
          payment-method-fields(:item="item", :fieldName="'payment-method-id'", slot="n1")
          payment-method-fields(:item="item", :fieldName="'payment-method-name'", slot="n2")
          payment-method-fields(:item="item", :fieldName="'payment-method-provider'", slot="n3")
          payment-method-fields(:item="item", :fieldName="'payment-method-created'", slot="n4")
          payment-method-fields(:item="item", :fieldName="'payment-method-updated'", slot="n5")
</template>
<script type="text/babel">
  import Card4 from 'components/structure/Card4'
  import Card3 from '../structure/Card3'
  import Card5 from '../structure/Card5.vue'
  import PaymentMethodFields from '../structure/ui/entity-fields/PaymentMethodFields.vue'
  import CardN from '../structure/CardN'
  import Dropdown from '../structure/foundation/Dropdown'
  import PaymentMethodButtons from '../structure/ui/actions/PaymentMethodButtons'

  export default {
    name: 'PaymentMethod',
    components: {
      PaymentMethodButtons,
      Dropdown,
      CardN,
      PaymentMethodFields,
      Card5,
      Card3,
      Card4,

    },
    data() {
      return {}
    },
    created() {
    },

    computed: {},
    props: {
      item: Object,
      type: {
        type: String,
        default: ''
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// PaymentMethod.vue?6f6a7a34